(function () {
  function initHeroSlider(sectionEl) {
    if (!sectionEl) return;

    if (sectionEl._heroSwiper) {
      sectionEl._heroSwiper.destroy(true, true);
      sectionEl._heroSwiper = null;
    }

    var swiperEl = sectionEl.querySelector('.hero-swiper');
    if (!swiperEl) return;

    var slides = swiperEl.querySelectorAll('.swiper-slide');
    var slideCount = slides.length;
    if (!slideCount) return;

    var autoplay = sectionEl.dataset.autoplay === 'true';
    var delay = parseInt(sectionEl.dataset.autoplayDelay, 10) || 5000;

    var swiper = new Swiper(swiperEl, {
      // Hero Max opts into infinite scroll (data-loop) for any multi-slide hero
      loop: sectionEl.dataset.loop === 'true' ? slideCount > 1 : slideCount > 2,
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: false,
      // Recalculate layout when the Shopify customizer mutates slide DOM
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      autoplay: autoplay ? { delay: delay, disableOnInteraction: false } : false,
      pagination: {
        el: sectionEl.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: sectionEl.querySelector('.swiper-button-next'),
        prevEl: sectionEl.querySelector('.swiper-button-prev')
      }
    });

    sectionEl._heroSwiper = swiper;
  }

  function getSectionEl(event) {
    // event.target is the section wrapper; the slider lives on the inner [data-hero-slider]
    if (event.target.matches && event.target.matches('[data-hero-slider]')) {
      return event.target;
    }
    return event.target.querySelector
      ? event.target.querySelector('[data-hero-slider]')
      : null;
  }

  // Navigate to the slide that owns the selected/edited block (loop-aware)
  function goToBlock(sectionEl, blockId) {
    var swiper = sectionEl && sectionEl._heroSwiper;
    if (!swiper || !blockId) return;
    var target = sectionEl.querySelector('.swiper-slide.slide-' + blockId);
    if (!target) return;
    var index = parseInt(target.getAttribute('data-swiper-slide-index'), 10);
    if (isNaN(index)) {
      // Non-loop mode: data-swiper-slide-index is absent, use DOM position
      var realSlides = sectionEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      index = Array.prototype.indexOf.call(realSlides, target);
    }
    if (index < 0) return;
    if (swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(index);
    } else {
      swiper.slideTo(index);
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHeroSlider(getSectionEl(event));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionEl = getSectionEl(event);
    if (sectionEl && sectionEl._heroSwiper) {
      sectionEl._heroSwiper.destroy(true, true);
      sectionEl._heroSwiper = null;
    }
  });

  // When a slide is selected in the customizer, pause autoplay and show it
  document.addEventListener('shopify:block:select', function (event) {
    var sectionEl = event.target.closest('[data-hero-slider]');
    if (!sectionEl || !sectionEl._heroSwiper) return;
    if (sectionEl._heroSwiper.autoplay) sectionEl._heroSwiper.autoplay.stop();
    goToBlock(sectionEl, event.detail && event.detail.blockId);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var sectionEl = event.target.closest('[data-hero-slider]');
    if (!sectionEl || !sectionEl._heroSwiper) return;
    if (
      sectionEl.dataset.autoplay === 'true' &&
      sectionEl._heroSwiper.autoplay
    ) {
      sectionEl._heroSwiper.autoplay.start();
    }
  });

  function initAll() {
    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }
})();
